<template>
  <span v-if="visible" class="subscriber-badge" :title="'Premium Subscriber'">
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'SubscriberBadge',
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.subscriber-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffa500;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-left: 4px;
}

.subscriber-badge svg {
  width: 100%;
  height: 100%;
}
</style>
